import React from 'react';

import * as S from './styles';

export const Dashboard: React.FC = () => {
  return <S.Container />;
};
